import {
    useEffect,
    createContext,
    useContext,
    useState,
    useReducer,
} from 'react'
import { io, Socket } from 'socket.io-client'
import currentConfig from '../config'
import { useAuth } from './AuthenticationContext'

const osmosisCurrentUrl: any = `${currentConfig.TELEMETRY_API_URL}`
const osmosisApiUrl: string = `${currentConfig.API_URL}`

console.log(osmosisCurrentUrl, 'current URL')
console.log(osmosisApiUrl, 'API URL')
interface SocketStateTypes {
    telemetrySocket: Socket | null
    apiSocket: Socket | null
    telemetrySocketConnected?: boolean
    apiSocketConnected?: boolean
}

const defaultState: SocketStateTypes = {
    telemetrySocket: null,
    apiSocket: null,
    telemetrySocketConnected: false,
    apiSocketConnected: false,
}

export const SocketContext = createContext<SocketStateTypes>(defaultState)

export const SocketContextProvider = ({ children }: any) => {
    const reducer = (oldState: any, newState: any) => ({
        ...oldState,
        ...newState,
    })
    const [state, setState] = useReducer(reducer, defaultState)
    const { telemetrySocket, apiSocket } = state

    const { auth } = useAuth()
    const { authenticated, idToken } = auth

    useEffect(() => {
        if (!authenticated || !idToken) {
            if (telemetrySocket) {
                telemetrySocket.disconnect()
            }
            if (apiSocket) {
                apiSocket.disconnect()
            }
            setState({ telemetrySocket: null, apiSocket: null })
            return
        }

        const connectSockets = async () => {
            // const newTelemetrySocket = io(osmosisCurrentUrl, {
            //     path: '/socket.io',
            //     auth: { token: idToken },
            //     withCredentials: false,
            // })

            const newApiSocket = io(`${osmosisApiUrl}/client`, {
                path: '/socket.io',
                withCredentials: false,
            })

            setState({
                // telemetrySocket: newTelemetrySocket,
                apiSocket: newApiSocket,
            })
        }

        connectSockets()

        return () => {
            if (telemetrySocket) {
                telemetrySocket.disconnect()
            }
            if (apiSocket) {
                apiSocket.disconnect()
            }
        }
    }, [authenticated, idToken])

    useEffect(() => {
        // if (telemetrySocket) {
        //     telemetrySocket.on('connect', () => {
        //         console.info('Telemetry Socket connected')
        //         setState({ telemetrySocketConnected: true })
        //     })
        //     telemetrySocket.on('disconnect', () => {
        //         console.info('Telemetry Socket disconnected')
        //         setState({ telemetrySocketConnected: false })
        //     })
        // }
        if (apiSocket) {
            apiSocket.on('connect', () => {
                console.info('API Socket connected')
                setState({ apiSocketConnected: true })
                if (auth?._id) {
                    apiSocket.emit('authenticate', auth._id)
                }
            })
            apiSocket.on('notifications:refresh', (data) => {
                console.info('Received notification')
                window.dispatchEvent(
                    new CustomEvent('notifications:refresh', { detail: data })
                )
            })

            apiSocket.on('disconnect', () => {
                console.info('API Socket disconnected')
                setState({ apiSocketConnected: false })
            })
            return () => {
                apiSocket.off('notifications:refresh')
            }
        }
    }, [telemetrySocket, apiSocket])

    return (
        <SocketContext.Provider value={state}>
            {children}
        </SocketContext.Provider>
    )
}

export const useSocket = () => useContext(SocketContext)
